import ErrorMessage from 'components/molecules/error-message'
import { Loader } from 'components/molecules/loader'
import { showHttpToast } from 'lib/show-toast'
import { debounce } from 'lodash'
import { useEffect, useMemo, useState } from 'react'
import { base64ToBlob } from 'utils/base64-to-blob'
import { PapeletaService } from '../services/papeleta.service'

export function PapeletaPdfDataProvider({ children, id, orientation = 'vertical' }) {
    const [data, setData] = useState(null)
    const [code, setCode] = useState(0)
    const [loading, setLoading] = useState(true)

    const load = useMemo(
        () =>
            debounce(async () => {
                setLoading(true)
                const { success, data, message, code } = await PapeletaService.download(id)
                if (success) {
                    const blob = base64ToBlob(data.b64_file, 'application/pdf')
                    setData(window.URL.createObjectURL(blob))
                    setCode(0)
                } else {
                    setData(null)
                    showHttpToast(success, { description: message })
                    setCode(code)
                }
                setLoading(false)
            }, 300),
        [],
    )

    useEffect(() => {
        load()
    }, [])

    if (loading) return <Loader />
    if (code || !data) {
        return <ErrorMessage type='resource' statusCode={code || 404} orientation={orientation} />
    }

    return children?.(data)
}
